import type { DisplayOptionsAction } from "@/pages/human-resources/time-management/model/display-options/DisplayOptionsAction.ts";
import { DisplayOptionsDispatchContext } from "@/pages/human-resources/time-management/model/display-options/DisplayOptionsDispatchContext.ts";
import type { Dispatch } from "react";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";

export default function useDisplayOptionsDispatch(): {
  dispatch: Dispatch<DisplayOptionsAction>;
  callback: (a: DisplayOptionsAction) => () => void;
} {
  const dispatch = useDefinedContextValue(DisplayOptionsDispatchContext);
  return {
    dispatch,
    callback: (a: DisplayOptionsAction): (() => void) => {
      return () => {
        dispatch(a);
      };
    },
  };
}
